import { render, staticRenderFns } from "./CardShared.vue?vue&type=template&id=2426a126"
import script from "./CardShared.vue?vue&type=script&lang=js"
export * from "./CardShared.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports